const checkOwnProperty = (obj = {}, prop = "") => {
  if (obj && obj.hasOwnProperty(prop)) {
    return obj[prop];
  } else {
    return null;
  }
};

export default checkOwnProperty;
